import { message } from 'antd';

import { getUploadFilePath } from '@/helpers/getUploadFilePath';
import { getAxiosWithAuth } from '@/lib/axios';
import type { Feedback } from '@/types/database/feedback';
import type { User } from '@/types/database/users';

import type {
  EditFeedback,
  FeedbackEditModalProps,
  FeedbackForm,
} from './types';

export const feedbackToFormValues = (feedback: Feedback): FeedbackForm => {
  const value: FeedbackForm = {
    householdNumber: feedback.householdNumber.split('-'),
    title: feedback.title,
    content: feedback.content,
    type: feedback.type,
    image: [],
  };
  if (feedback.image) {
    value.image.push({
      uid: Math.random().toString(),
      name: feedback.image.name,
      status: 'done',
      url: feedback.image.path,
    });
  }
  return value;
};

export const getHandleFinish = (
  editingFeedback: FeedbackEditModalProps['editingFeedback'],
  user: User
) => {
  const handleFinish = async (values: FeedbackForm) => {
    if (!user._id || !user.name) {
      return;
    }
    const newFeedback: EditFeedback = {
      householdNumber: values.householdNumber.join('-'),
      title: values.title,
      content: values.content,
      type: values.type,
      user: {
        id: user._id,
        name: user.name,
      },
      image: null,
    };
    const type = editingFeedback ? '更新' : '新增';
    try {
      if (values.image?.[0]?.originFileObj) {
        const path = await getUploadFilePath(
          values.image[0].originFileObj,
          'feedback'
        );
        newFeedback.image = {
          name: values.image[0].name,
          path: path,
        };
      }
      const axios = getAxiosWithAuth();
      if (editingFeedback) {
        await axios.patch(
          `/ezcon/api/feedbacks/${editingFeedback._id}`,
          newFeedback
        );
      } else {
        await axios.post('/ezcon/api/feedbacks', newFeedback);
      }
      message.success(`${type}意見反應成功`);
    } catch (error) {
      console.error(error);
      message.error(`${type}意見反應失敗`);
    }
  };
  return handleFinish;
};
